import { render } from "./Clients.vue?vue&type=template&id=5776a5ed&scoped=true"
import script from "./Clients.vue?vue&type=script&lang=js"
export * from "./Clients.vue?vue&type=script&lang=js"

import "./Clients.vue?vue&type=style&index=0&id=5776a5ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5776a5ed"]])

export default __exports__